<template>
  <transition name="el-zoom-in-right">
    <div class="message-box" v-show="visible">
      <div class="header">
        <span class="title">持续响应任务列表</span>
        <i class="el-icon-close close" @click="close"></i>
      </div>
      <div class="body">
        <div class="params">
          <el-select v-model="controllerPsn" filterable allow-create default-first-option>
            <el-option value="00000002000180001100013000100039"></el-option>
          </el-select>
          <el-button style="margin-left: 8px" @click="loadRequestTaskList" :loading="searching">查询</el-button>
        </div>
        <div>
          <div class="item none" v-show="list.length === 0">暂无数据</div>
          <div class="item" v-for="item in list" :key="item.id">
            {{ item.id }}
            {{ item.close ? '已停止' : '运行中' }}
            <el-button type="text" @click="stopRequestTask(item.id)">停止</el-button>
          </div>
        </div>
      </div>
      <audio id="qnaudio" ref="qnaudio" :src="url" autoplay="true" loop="loop"></audio>
    </div>
  </transition>
</template>

<script>
// eslint-disable-next-line no-unused-vars
import Vue from 'vue'
import {getStompClient, responseDurationList, responseDurationStop} from "@/api/remote";
import fault from "../../assets/audio/Fault.wav"
import fire from "../../assets/audio/Fire.wav";
import { stopRecord } from 'api/query'

export default {
  name: "Message",
  props: {
    visible: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      searching: false,
      list: [],
      controllerPsn: '',
      faultUrl: fault,
      fireUrl: fire,
      url: "",
    }
  },
  computed: {
    controllInfo(){
      return this.$store.state.controlInfo
    },
    debugFlag(){
      return this.$store.state.debugFlag
    },
    formData() {
      return this.$store.state.formData
    },
    user() {
      return this.$store.state.userInfo;
    },
    accessToken() {
      return this.$store.state.token;
    },
    relateData() {
      return this.$store.state.relateData
    },
    // 控制播放火警音标识alarmFlag 故障声音faultFlag
    alarmFlag() {
      return this.fireCount !== "0000" || this.regularCount !== "0000" || this.shieldCount !== "0000" || this.feedbackCount !== "0000"
    },
    faultFlag() {
      return this.faultCount !== "0000"
    },
    fireCount() {
      return this.$store.state.fireCount
    },
    faultCount() {
      return this.$store.state.faultCount
    },
    regularCount() {
      return this.$store.state.regularCount
    },
    shieldCount() {
      return this.$store.state.shieldCount
    },
    feedbackCount() {
      return this.$store.state.feedbackCount
    },
    faultReceive() {
      return this.$store.state.faultReceive
    },
    sysSetting() {
      return this.$store.state.sysSetting
    },
    muteFlag(){
      return this.$store.state.muteFlag
    },
  },
  mounted() {
    this.getAlarmNum();
  },
  watch: {
    muteFlag(val){
      if (val) {
        this.url = ""
      } else {
        if (this.alarmFlag) {
          this.url = this.fireUrl
        } else if (this.faultFlag && !this.alarmFlag) {
          this.url = this.faultUrl;
        }
      }
    },
    accessToken: {
      handler() {
        this.openClient();
      },
      immediate: true,
    },
    "$store.state.monicentorList": {
      handler(newVal) {
        this.getAlarmNum();
      },
      deep: true
    },
    // 控制器信息更新后 存储到本地  更新控制器信息 修改调试模式
    "$store.state.controlInfo": {
      handler(newVal) {
        // r如果不是处于开始调试状态 不接收消息 此处只处理控制器信息
        // if (!this.debugFlag) return
        // console.log(newVal, "kongzhiqi ",this.debugFlag,"debugFlag")
        // if (this.debugFlag) {
        //   this.$store.commit('changeDebugFlag', false); // 倒计时结束 暂时算通过
        //   localStorage.setItem('debugFlag', false)
        //   sessionStorage.debugFlag = false;
        // }
        newVal.controllerPsn = newVal.psn;
        newVal.manualStat = newVal.manual;
        newVal.autoStat = newVal.automatic;
        this.$store.commit('setControlInfo', newVal);
        sessionStorage.controlInfo = JSON.stringify(newVal)
        let formData = JSON.parse(JSON.stringify(this.formData))
        let sysSetting = Object.assign({}, newVal, formData)
        this.$store.commit('setSysSetting', sysSetting);
        sessionStorage.sysSetting = JSON.stringify(sysSetting)
        // this.$emit("enable", sessionStorage.debugFlag)
        // this.$router.replace('/monitor/monitor');
      },
      deep: true
    },
    alarmFlag(val) {
      console.log(this.muteFlag)
      if (val && !this.muteFlag) {
        this.url = this.fireUrl;
      }
    },
    faultFlag(val) {
      console.log(this.muteFlag)
      if (val && !this.alarmFlag && !this.muteFlag) {
        this.url = this.faultUrl;
      }
    },
  },
  methods: {
    _stopRecord(psn) {
      stopRecord({controllerPsn: psn, id: this.sysSetting.recordId}).then((res) => {
        if (res.code === 1) {
          this.$message.success(res.message)
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    loadRequestTaskList() {
      if (!this.controllerPsn) {
        this.$message.success("请选择PSN");
        return
      }
      this.searching = true;
      responseDurationList({controllerPsn: this.controllerPsn}).then(res => {
        this.list = res.data;
      }).finally(() => this.searching = false)
    },
    stopRequestTask(id) {
      responseDurationStop({controllerPsn: this.controllerPsn, requestId: id}).then(res => {
        this.$message.success("停止命令已发送")
      })
    },
    close() {
      this.$emit('update:visible', false);
    },
    openClient() {
      if (!this.accessToken) {
        return
      }
      this.closeClient();
      let stompClient = getStompClient(this.accessToken);
      stompClient.debug = () => {
      };
      stompClient.reconnectDelay = 120000;
      stompClient.connect({}, () => {
        // 保持全局引用
        Vue.prototype.$stompClient = stompClient;
        // 订阅
        stompClient.subscribe(`/user/${this.user.username}/alarm`, (msg) => {
          console.log(msg.body)
          let body = msg.body;
          body = JSON.parse(body);
          // 开始调试
          if (body.msgType === 1) {
            if (body.online === 0) { // 连接断开
              // return
              // 处于未连接状态, 不处理
              console.log(this.debugFlag,"body.online === 0 debugFlag")
              if (!this.debugFlag) return
              this.$store.commit('changeDebugFlag', false);
              /** 置为false 或者删除 */
              sessionStorage.removeItem("controlAuth");
              this.$store.commit("setControlAuth", [])
              localStorage.setItem('homeShow', true)
              localStorage.setItem('isMonitor', true)
              this.$store.commit('setSideBarActive', 'monitor')
              localStorage.setItem('sideBarActive', 'monitor')
              sessionStorage.debugFlag = false;
              localStorage.setItem('debugFlag', false)
              this.$store.commit('changeDebugFlag', false)
              let DebugData = {
                dynamicKeyExpir: body.dynamicKeyExpir,
                bwait: body.bwait
              }
              this.$store.commit('setDebugData', DebugData);
              sessionStorage.DebugData = JSON.stringify(DebugData)
              this.$store.commit('changeDebugSeconds', body.dynamicKeyExpir);
              sessionStorage.debugSeconds = body.dynamicKeyExpir;
              // 初始化 startAndStop
              this.$store.commit('changeStartAndStop', "");
              sessionStorage.startAndStop = "";
              this.$store.commit('changeResponse', true);
              sessionStorage.responseErrFlag = true
              return
            }
            let psn = body.controller.psn;
            if (body.checkDistributor === 0) {
              this.$message.error(`控制器PSN（${psn}）检查有跨区行为，无法连接`)
            } else if (body.checkDistributor === 1) {
              console.log(this.debugFlag,"body.checkDistributor == 1 debugFlag")
              this.$store.commit('changeDebugFlag', true); // 倒计时结束 暂时算通过
              localStorage.setItem('debugFlag', true)
              sessionStorage.debugFlag = true;
              this.$store.commit('changeResponse', false);
              sessionStorage.responseErrFlag = false
              body.controller.projectName = body.projectName;
              this.$store.commit('setControlInfo', body.controller);
              sessionStorage.controlInfo = JSON.stringify(body.controller)
              // 清空 错误信息 以便于下次错误捕捉
              let debugData = JSON.parse(sessionStorage.DebugData || '{}')
              delete debugData.bwait
              this.$store.commit('setDebugData', debugData);
              sessionStorage.DebugData = JSON.stringify(debugData)
            } else if (body.checkDistributor === 2) {
              this.$confirm(`控制器PSN（${psn}）已连接，但未找到相关信息, 是否进入调试`, '提示', {
                confirmButtonText: '是',
                cancelButtonText: '否',
                type: 'warning'
              }).then(() => {
                this.$store.commit('changeResponse', false);
                sessionStorage.responseErrFlag = false
                body.controller.projectName = body.projectName;
                this.$store.commit('setControlInfo', body.controller);
                sessionStorage.controlInfo = JSON.stringify(body.controller)
                this.$store.commit('changeDebugFlag', true);
                sessionStorage.debugFlag = true;
              }).catch(() => {
                this._stopRecord(psn);
                this.$store.commit('changeDebugFlag', false);
                sessionStorage.debugFlag = false;
              });
            }
          }
          // 事件
          if (body.msgType === 2) {
            if (!this.debugFlag) return
            body.msg.forEach(data => {
              this.dealSocketData(data)
            })
          }
          // 持续应答事件
          if (body.msgType === 3) {
            if (!this.debugFlag) return
            this.$store.commit('changeResponse', false);
            sessionStorage.responseErrFlag = false
            let obj = {
              dataUint: body.dataUint,
              request: body.request
            }
            if (body.dataUintType === 20) { // 现场部件数据
              this.$store.commit('setCurrentComponentData', Object.assign({}, obj));
            } else if (body.dataUintType === 12) { // 探测器模拟曲线
              this.$store.commit('setCurrentAnalogLine', Object.assign({}, obj));
            } else if (body.dataUintType === 13) { // 回路状态浏览
              this.$store.commit('setCurrentLoopStatus', Object.assign({}, obj));
            }
          }
          // 处理持续响应异常
          if (body.msgType === 4) {
            if (!this.debugFlag) return
            if (body.error) this.$message.error(body.error)
            // this.$notify.error({title: body.error, position: 'bottom-right'});
            this.$store.commit('changeStartAndStop', "");
            sessionStorage.startAndStop = "";
            this.$store.commit('changeResponse', true);
            sessionStorage.responseErrFlag = true
          }
          // 响应结束
          if (body.msgType === 5) {
            if (!this.debugFlag) return
            this.$store.commit('changeStartAndStop', "");
            sessionStorage.startAndStop = "";
            this.$store.commit('changeResponse', true);
            sessionStorage.responseErrFlag = true
          }
        })
      });
    },
    closeClient() {
      // 销毁stomp连接
      if (this.$stompClient) {
        this.$stompClient.deactivate()
        this.$stompClient.disconnect()
      }
    },
    dealSocketData(data) {
      // 如果是故障 接收还是不接收
      if (!this.faultReceive && data.val === 6) {
        return
      }
      // 判断复位 清空数据
      if (data.val === 33) {
        this.$store.state.monicentorList = []
        sessionStorage.monicentorList = JSON.stringify(this.$store.state.monicentorList)
        return
      }
      // 判断数据是否重复 重复 返回
      let localList = this.$store.state.monicentorList
      let index = localList.findIndex(v => {
        return v.controllerNo === data.controllerNo &&
            v.loopNo === data.loopNo &&
            v.codeNo === data.codeNo
      })
      // 数据存在
      if (index !== -1) {
        let currentData = localList[index];
        // 判断重复数据
        if (currentData.val === data.val) return
        // 判断是否撤销
        // 在撤销数组中 存在当前数据 表明这是一条撤销命令
        let releteIndex = this.relateData.findIndex(v => v.code === data.val)
        console.log(this.relateData,"this.relateData")
        let cancelFlag = (releteIndex !== -1) ? true : false;
        if (cancelFlag) { // 撤销
          let releteArr = this.relateData[releteIndex].relate.split(",");
          console.log(releteArr,"releteArr")
          // this.$store.state.monicentorList.splice(index, 1)
          let arr = this.$store.state.monicentorList.filter(v => {
            return !releteArr.includes(String(v.val))
          })
          console.log(arr,"arr")
          this.$store.state.monicentorList = arr;
        } else {
          this.$store.state.monicentorList.push(data)
        }
      } else {
        // 撤销命令
        let releteIndex = this.relateData.findIndex(v => v.code === data.val)
        let cancelFlag = (releteIndex !== -1) ? true : false;
        if (!cancelFlag) { // 撤销
            this.$store.state.monicentorList.push(data)
        }
      }
      sessionStorage.monicentorList = JSON.stringify(this.$store.state.monicentorList)
    },
    getAlarmNum() {
      //fireCount: "0000", faultCount: "0000", regularCount: "0000", shieldCount: "0000", feedbackCount: "0000",
      // type:  1: 火警  6:故障  5: 监管  7: 屏蔽  3\4: 联动反馈
      let list = this.$store.state.monicentorList
      let fireCount = this.dealNum(list.filter(v => v.type === 1).length)
      let faultCount = this.dealNum(list.filter(v => v.type === 6).length)
      let regularCount = this.dealNum(list.filter(v => v.type === 5).length)
      let shieldCount = this.dealNum(list.filter(v => v.type === 7).length)
      let feedbackCount = this.dealNum(list.filter(v => v.type === 3 || v.type === 4).length)
      this.$store.commit('setFireCount', fireCount);
      this.$store.commit('setFaultCount', faultCount);
      this.$store.commit('setRegularCount', regularCount);
      this.$store.commit('setShieldCount', shieldCount);
      this.$store.commit('setFeedbackCount', feedbackCount);
    },
    dealNum(num) {
      if (num < 10) {
        return "000" + num
      } else if (num >= 10 && num < 100) {
        return "00" + num
      } else if (num >= 100 && num < 1000) {
        return "0" + num
      } else if (num >= 1000) {
        return num
      }
    },
  },
  beforeDestroy() {
    this.closeClient();
  }
}
</script>

<style lang="scss" scoped>
.message-box {
  position: absolute;
  z-index: 9;
  right: 0;
  height: 100vh;
  width: 380px;
  border-left: 1px solid #DCDFE6;
  background-color: #FFFFFF;

  .header {
    position: relative;
    display: flex;
    align-items: center;
    height: 40px;
    border-bottom: 1px solid #DCDFE6;
    background-color: #E4E7ED;

    .title {
      font-size: 18px;
      padding-left: 10px;
    }

    .close {
      position: absolute;
      right: 10px;
      cursor: pointer;
    }
  }

  .params {
    padding: 0 5px 10px 5px;
  }

  .item {
    font-size: 14px;
    border-top: 1px solid #dcdfe6;
    padding: 5px;
  }

  .none {
    text-align: center;
    color: #909399;
  }
}

.el-zoom-in-right-enter-active, .el-zoom-in-right-leave-active {
  opacity: 1;
  transform: scale(1, 1);
  transition: opacity .3s cubic-bezier(.23, 1, .32, 1);
  transition: transform .3s cubic-bezier(.23, 1, .32, 1), opacity .3s cubic-bezier(.23, 1, .32, 1);
  transition: transform .3s cubic-bezier(.23, 1, .32, 1), opacity .3s cubic-bezier(.23, 1, .32, 1);
  transform-origin: right;
}

.el-zoom-in-right-enter, .el-zoom-in-right-leave-active {
  opacity: 0;
  transform: scale(.45, .45)
}

</style>
